import {
    createLockedCalendarEventsStore,
    getLockedCalendarEventsReader,
} from 'owa-calendar-events-store';

export const calendarEventsLockedStore = createLockedCalendarEventsStore();
export const calendarEventsLockedStoreReader = getLockedCalendarEventsReader(
    calendarEventsLockedStore.getLockId()
);
